<template>
  <div class="flex items-center justify-between">
    <div :class="imgSizeStyle({ mode: props.mode })">
      <OptimizedImage :class="['h-full w-full object-cover']" :image-url="props.img" :optimized-image-options="{ width: 240 }" />
    </div>
    <h3 :class="['flex-1 text-black1', props.textStyle]">
      <span v-if="slug">
        <nuxt-link class="cursor-pointer" @click="onClickImage">{{ props.title }}</nuxt-link>
      </span>
      <span v-else>
        {{ props.title }}
      </span>
    </h3>
  </div>
</template>

<script setup lang="ts">
import { tv } from 'tailwind-variants';

import OptimizedImage from '@/wabunka-src/common/components/stateful/OptimizedImage/OptimizedImage.vue';

interface Props {
  title: string;
  img: string;
  slug: string;
  textStyle?: string;
  mode?: 'NORMAL' | 'SMALL';
  onClickImage: () => void;
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  img: '',
  slug: '',
  textStyle: 'text-sm font-light leading-[22px] tracking-wider',
  mode: 'NORMAL',
});

const imgSizeStyle = tv({
  base: 'mr-[18px]',
  variants: {
    mode: {
      NORMAL: 'h-[68px] w-[68px]',
      SMALL: 'h-[48px] w-[48px]',
    },
  },
});
</script>
